export const ClockIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg'
         width='16'
         height='16'
         viewBox='0 0 16 16'
    >
      <g id='Gruppe_2717'
         data-name='Gruppe 2717'
         transform='translate(-23906 21026)'
      >
        <g id='Ellipse_83'
           data-name='Ellipse 83'
           transform='translate(23906 -21026)'
           fill='none'
           stroke='currentColor'
           strokeWidth='1'>
          <circle cx='8'
                  cy='8'
                  r='8'
                  stroke='none'
          />
          <circle cx='8'
                  cy='8'
                  r='7.5'
                  fill='none'
          />
        </g>
        <path id='Pfad_357'
              data-name='Pfad 357'
              d='M23928.131-21033.5v5.631l-2.666,2.369'
              transform='translate(-14.131 10.619)'
              fill='none'
              stroke='currentColor'
              strokeWidth='1'
        />
      </g>
    </svg>

  );
};